// Mirrors `Doi.Npcs.slugify/1` so the admin NPC deck UI can preview the
// slug client-side without a round trip. Lowercases, **drops** any
// apostrophes (so "Pip's Duel Deck" → `pips_duel_deck`, not the older
// `pip_s_duel_deck`), collapses runs of every other non-`[a-z0-9]` char
// to `_`, trims edge underscores, and clamps to 64 chars.
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/['‘’]+/g, "") // straight + curly apostrophes: drop
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 64);
}
